import { useMutation, useQueryClient } from "@tanstack/react-query";

import { updateVerificationStatus } from "services";

import { invalidateQueriesByChunk } from "utils";

import { GET_FIELD_PRACTICES, GET_FIELD_VERIFICATIONS, UPDATE_VERIFICATION_STATUS } from "consts";

export const useUpdateVerificationStatus = ({ fieldId, farmId }: { fieldId: string; farmId: string }) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: [UPDATE_VERIFICATION_STATUS, fieldId],
    mutationFn: updateVerificationStatus,
    onSuccess: () => {
      const queryKeys = [
        [GET_FIELD_PRACTICES, fieldId],
        [GET_FIELD_VERIFICATIONS, farmId],
      ];

      Promise.all(queryKeys.map((queryKey) => queryClient.invalidateQueries({ queryKey })));
      invalidateQueriesByChunk(GET_FIELD_PRACTICES, fieldId);
    },
  });
};
